export const pageProjectsData = [
  {
    id: 9,
    title: "Actus RH",
    date: "",
    infos: "",
    img1: "./assets/img/actus-rh/2020sem10.jpg",
    img2: "./assets/img/actus-rh/2020sem13.jpg",
    img3: "./assets/img/actus-rh/2020sem14.jpg",
    img4: "./assets/img/actus-rh/2020sem15.jpg",
    img5: "./assets/img/actus-rh/2020sem16.jpg",
    img6: "./assets/img/actus-rh/2020sem17.jpg",
    img7: "./assets/img/actus-rh/2020sem18.jpg",
    img8: "./assets/img/actus-rh/2020sem20.jpg",
    img9: "./assets/img/actus-rh/2020sem21.jpg",
    img10: "./assets/img/actus-rh/2020sem22.jpg",
    img11: "./assets/img/actus-rh/2020sem23.jpg",
    img12: "./assets/img/actus-rh/2020sem24.jpg",
    img13: "./assets/img/actus-rh/2020sem26.jpg",
    img14: "./assets/img/actus-rh/2020sem27.jpg",
    img15: "./assets/img/actus-rh/2020sem28.jpg",
    img16: "./assets/img/actus-rh/2020sem30.jpg",
    img17: "./assets/img/actus-rh/2020sem32.jpg",
    img18: "./assets/img/actus-rh/2020sem33.jpg",
    img19: "./assets/img/actus-rh/2020sem35.jpg",
    img20: "./assets/img/actus-rh/2020sem36.jpg",
    img21: "./assets/img/actus-rh/2020sem37.jpg",
    img22: "./assets/img/actus-rh/2020sem38.jpg",
    img23: "./assets/img/actus-rh/2020sem39.jpg",
    img24: "./assets/img/actus-rh/2020sem41.jpg",
    img25: "./assets/img/actus-rh/2020sem42.jpg",
    img26: "./assets/img/actus-rh/2020sem43.jpg",
    img27: "./assets/img/actus-rh/2020sem44.jpg",
    img28: "./assets/img/actus-rh/2020sem46.jpg",
    img29: "./assets/img/actus-rh/2020sem47.jpg",
    img30: "./assets/img/actus-rh/2020sem49.jpg",
    img31: "./assets/img/actus-rh/2020sem51.jpg",
    img32: "./assets/img/actus-rh/2021sem02.jpg",
    img33: "./assets/img/actus-rh/2021sem07.jpg",
    img34: "./assets/img/actus-rh/2021sem08.jpg",
    img35: "./assets/img/actus-rh/2021sem38.jpg",
  },

  {
    id: 10,
    title: "Visuels de com",
    date: "",
    infos: "",
    img1: "./assets/img/visuels-com/001-visuel-com.jpg",
    img2: "./assets/img/visuels-com/002-visuel-com.jpg",
    img3: "./assets/img/visuels-com/003-visuel-com.jpg",
    img4: "./assets/img/visuels-com/004-visuel-com.jpg",
    img5: "./assets/img/visuels-com/005-visuel-com.jpg",
    img6: "./assets/img/visuels-com/006-visuel-com.jpg",
    img7: "./assets/img/visuels-com/007-visuel-com.jpg",
    img8: "./assets/img/visuels-com/008-visuel-com.jpg",
    img9: "./assets/img/visuels-com/009-visuel-com.jpg",
    img10: "./assets/img/visuels-com/010-visuel-com.jpg",
  },

  {
    id: 11,
    title: "Logos",
    date: "",
    infos: "",
    img1: "./assets/img/logos/001-logo.jpg",
    img2: "./assets/img/logos/002-logo.jpg",
    img3: "./assets/img/logos/003-logo.jpg",
    img4: "./assets/img/logos/004-logo.jpg",
  },

  {
    id: 12,
    title: "Bandes dessinées",
    titlebd1: "Sémaphore",
    infos1:
      "C’est avec émotion que Serge retrouve la petite cité balnéaire où il a passé son enfance. Il est ici pour faire ranimer le peu de souvenirs de la jeunesse de son père, décédé depuis peu, et avec lequel il n’a pas pris le temps de parler. En allant chez le notaire, il hérite d’une petite boîte contenant quelques lettres et des photos de son père en compagnie de ses amis de l’époque. Pourquoi celui-ci a-t-il tant tenu à lui léguer ainsi une partie de ses instants ? Que s’est-il déroulé de si remarquable en cette année 1964 et qu’est devenu Héloïse auquel le père de Serge tenait tant ? C’est ce que va tenter de découvrir le jeune homme, une enquête qui va l’amener à rencontrer Mathilde, la fille d’Héloïse.",
    img1: "./assets/img/bd/001-semaphore.jpg",
    img2: "./assets/img/bd/002-semaphore.jpg",
    img3: "./assets/img/bd/003-semaphore.jpg",
    img4: "./assets/img/bd/004-semaphore.jpg",
    img5: "./assets/img/bd/005-semaphore.jpg",
    img6: "./assets/img/bd/006-semaphore.jpg",
    img7: "./assets/img/bd/007-semaphore.jpg",
    img8: "./assets/img/bd/008-semaphore.jpg",
    titlebd2: "Les mauvais coups",
    infos2:
      "1928, Edmond, un jeune médecin, tombe amoureux d'une gitane. Par souci des convenances, cette idylle restera secrète... Ou presque. 1971, du côté de La Rochelle, Pierre s'est mis dans une sacrée panade. Garçon sans histoire, il a fini par céder à son « ami » Olivier en acceptant un boulot qui sent le traquenard à plein nez. Il faut dire que Clarisse, la soeur d'Olivier, a des arguments particulièrement convaincants... Ainsi, depuis quelques semaines, Pierre est devenu l'aide à domicile de Margot, une vieille dame qui dissimulerait chez elle - à en croire Olivier - une coquette somme d'argent. La mission de Pierre consiste à trouver où, puis à laisser Olivier et l'inquiétant José s'occuper du reste. Seulement Pierre finit par s'attacher à sa patronne... Si plus de 40 ans séparent ces deux histoires, un lien terrible les unit et ne demande qu'à revenir à la surface...",
    img9: "./assets/img/bd/009-les-mauvais-coups.jpg",
    img10: "./assets/img/bd/010-les-mauvais-coups.jpg",
    img11: "./assets/img/bd/011-les-mauvais-coups.jpg",
    img12: "./assets/img/bd/012-les-mauvais-coups.jpg",
    img13: "./assets/img/bd/013-les-mauvais-coups.jpg",
    img14: "./assets/img/bd/014-les-mauvais-coups.jpg",
    img15: "./assets/img/bd/015-les-mauvais-coups.jpg",
    img16: "./assets/img/bd/016-les-mauvais-coups.jpg",
  },

  {
    id: 13,
    title: "Éditions jeunesse",
    titlestory1: "« Il pleut, il mouille ! »",
    img1: "./assets/img/jeunesse/001-jeunesse.jpg",
    titlestory2: "« Le roi des roses »",
    img2: "./assets/img/jeunesse/002-jeunesse.jpg",
    titlestory3: "« Crocodiles »",
    img3: "./assets/img/jeunesse/003-jeunesse.jpg",
    titlestory4: "« L'oeuf de Jade »",
    img4: "./assets/img/jeunesse/004-jeunesse.jpg",
  },

  {
    id: 14,
    title: "Pochettes de disques",
    img1: "./assets/img/disques/001-disque.jpg",
    img2: "./assets/img/disques/002-disque.jpg",
    img3: "./assets/img/disques/003-disque.jpg",
    img4: "./assets/img/disques/004-disque.jpg",
  },

  {
    id: 15,
    title: "Sweat-shirts",
    img1: "./assets/img/sweats/001-sweat.gif",
    img2: "./assets/img/sweats/002-sweat.gif",
    img3: "./assets/img/sweats/003-sweat.gif",
    img4: "./assets/img/sweats/004-sweat.gif",
    img5: "./assets/img/sweats/005-sweat.gif",
    img6: "./assets/img/sweats/006-sweat.gif",
    img7: "./assets/img/sweats/007-sweat.gif",
    img8: "./assets/img/sweats/008-sweat.gif",
    img9: "./assets/img/sweats/009-sweat.gif",
  },

  {
    id: 16,
    title: "Planches de skate",
    img1: "./assets/img/skates/001-skate.jpg",
    img2: "./assets/img/skates/002-skate.jpg",
    img3: "./assets/img/skates/003-skate.jpg",
  },

  {
    id: 17,
    title: "Aéronautique",
    img1: "./assets/img/aero/001-aeronautique.jpg",
    img2: "./assets/img/aero/002-aeronautique.jpg",
    img3: "./assets/img/aero/003-aeronautique.jpg",
    img4: "./assets/img/aero/004-aeronautique.jpg",
  },
];
